import { UserRoleEnum } from 'app/services/user';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export interface IProtectedRoutesProps {
  user?: string;
}

export default function ProtectedRoutes({ user }: IProtectedRoutesProps) {
  const { role, dashboard } = useAuth();

  return user === role ? <Outlet /> : <Navigate to={dashboard} />;
}
